import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEOHelmet = ({
  title = "Ceremonzy - Premium Wedding Vendor Platform",
  description = "Ceremonzy is India's leading wedding vendor platform. Discover and book premium wedding vendors, photographers, caterers, decorators, and more for your perfect ceremony.",
  keywords = "Ceremonzy, wedding vendors, wedding planning, Indian weddings, wedding photographers, wedding caterers, wedding decorators, ceremony vendors, wedding services, marriage planning",
  image = "/images/ceremonzy-og-image.jpg",
  url = "https://ceremonzy.com/",
  type = "website",
  structuredData = null
}) => {
  const baseUrl = "https://ceremonzy.com";
  const fullUrl = url.startsWith('http') ? url : `${baseUrl}${url}`;
  const fullImageUrl = image.startsWith('http') ? image : `${baseUrl}${image}`;

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={fullUrl} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={fullImageUrl} />
      <meta property="og:site_name" content="Ceremonzy" />
      <meta property="og:locale" content="en_IN" />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={fullUrl} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={fullImageUrl} />
      <meta name="twitter:site" content="@Ceremonzy" />
      
      {/* Structured Data */}
      {structuredData && (
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      )}
    </Helmet>
  );
};

export default SEOHelmet;